import React from 'react';

/**
 * Legacy offline removal: this component used to walk the host's legacy
 * `OfflineOrderContext` orders and pre-fetch their thumbnails. With the host no
 * longer holding order data (each MF owns its offline + file cache via
 * `@4r/common-module-offline-services`), there is nothing to preload here, so
 * the component is now a pass-through.
 */
const ImagePreloader: React.FunctionComponent = ({ children }) => <>{children}</>;

export default ImagePreloader;
